import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";

import COMPANY_LOGO from '../../common/images-new/nie-logo-white.png'
import { dataNavlink } from '../../data/navlink'
import DropdownIcon from '../../common/images-new/dropdown-icon.svg'
import HamburgerIcon from '../../common/images-new/hamburger-icon.svg'
import NavbarLink from "./NavbarLink";
import Cross from "../../common/images-new/cross-icon.svg"
import EditProfileIcon from '../../common/images-new/edit-profile-icon.svg'
import LogoutIcon from '../../common/images-new/logout-icon.svg'
import Swal from "sweetalert2";
import { loadVBE, logoutUser, loadUser } from '../../redux/actions/auth'
import { staticFiles } from "../Helpers/Static";
import { BgBlue, Card, LiDiv, TextDarkBlue, TextGray, MenuItemCard, MenuItemDiv, NavCard } from "../../pages/Theme";
import { tokenAuthorize } from "../Helpers/Common";
import { getUserNavigationConfrimPopup } from "../../redux/actions/commonAction";
import axios from "axios";
import { serverUrl } from "../Helpers/Config";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { makeStyles } from '@mui/styles';
import { Button } from "@mui/material";
// const COMPANY_LOGO = staticFiles.nieLogo;
import { getProfilePic, trimString } from '../Helpers/Common';
import DoneIcon from '@mui/icons-material/Done';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { ExpandLess } from "@material-ui/icons";
import { ExpandMore } from "@material-ui/icons";

const Navbar = ({ profilePhoto, username, email, guid, isNavShown }) => {
	const dispatch = useDispatch();
	const userProfile = useSelector(state => state.auth.user);
	const reflectionFeedbackProcessing = useSelector((state) => state.reflectionFeedbackReducer.reflectionFeedbackProcessing || false);
	const userNavigatingConfrimPopup = useSelector((state) => state.commonData.userNavigatingConfrimPopup || false);
	const [click, setClick] = useState(false)
	const [dropdown, setDropdown] = useState(false)
	const [menuList, setmenuList] = useState([])
	const [userMenuFinal, setuserMenuFinal] = useState([])
	// const [vbelist, setvbelist] = useState({})
	const [subMenuAnchor, setSubMenuAnchor] = useState(null);
	const [mblsubMenuAnchor, setMblsubMenuAnchor] = useState(false);
	const [learnerProfile, setLearnerProfileList] = useState([])
	const handleSubmenuOpen = (event) => {
		setSubMenuAnchor(event.currentTarget);
	};

	const handleSubmenuClose = () => {
		setSubMenuAnchor(null);
	};

	const userTheme = useSelector(state => state.auth.theme);
	const isDefaultTheme = useSelector(state => state.auth.isDefaultTheme);

	const useStyles = makeStyles((theme) => ({
		customMenu: {
			backgroundColor: isDefaultTheme == false && userTheme ? `${userTheme?.color3} !important` : 'white !important',
			width:'200 !important;'
		},
		nestedMenu: {
			pointerEvents: "none",
			paddingRight: 20, // add right space
			minWidth: 180,
		},
		nestedContent: {
			pointerEvents: "auto"
		}
	}));

	const getUserMenu = () => {
		const role = (userProfile && userProfile.role) ? userProfile.role : 'MEMBER';

		switch (role) {
			case 'MANAGER':
				return dataNavlink;
			case 'MEMBER':
			default:
				return dataNavlink.filter(menuItem => (menuItem.member === true))
		}
	}

	const userMenu = getUserMenu();

	useEffect(() => {

		const getData = async () => {
			await dispatch(loadVBE(userProfile?.guid));
			const responseCourses = await axios.get(
				serverUrl.GetMenus2 + '/' + guid
			).then(resp => {
				if (resp.status === 200) {
					setmenuList(resp.data)
					let data = [];
					resp?.data && resp?.data?.map((r) => (
						userMenu.map((s) => (
							((s.title?.toLowerCase() === "my showcase" && r.menu_name.toLowerCase() === "my showcase")) ? data.push(s) : "",
							(r.menu_name?.toLowerCase() === s.title?.toLowerCase() && r.menu_name?.toLowerCase() != "my showcase") ? data.push(s) : ""
						))
					))
					// let response = userMenu?.filter((s) => s.title == "VBE")[0];
					// data.push(response);
					setuserMenuFinal(data);
				}
			})
				.catch(err => {
					tokenAuthorize(err?.response?.status);
					console.log(err)
				})
		}
		getData();
	}, [])

	useEffect(() => { }, [userNavigatingConfrimPopup]);

	//Learner Profile
	useEffect(() => {
		if (userProfile?.user_id) {
			axios.get(serverUrl.LearnerProfiles + userProfile?.user_id).then(resp => {
				if (resp.status === 200) {
					setLearnerProfileList(resp?.data?.results);
				}
			}).catch(err => {
				tokenAuthorize(err?.response?.status);
			});
		}
	}, []);

	const handleClick = () => {
		if (userNavigatingConfrimPopup) {
			Swal.fire({
				heightAuto: false,
				title: "Changes not saved",
				text: "Are you sure to leave this page?",
				icon: "warning",
				showCancelButton: false,
				showDenyButton: true,
				confirmButtonText: "Confirm",
				denyButtonText: "Cancel",
				confirmButtonColor: "#3085d6",
				denyButtonColor: "#c1c1c1",
			}).then((result) => {
				if (result.isConfirmed) {
					setClick(!click);
					dispatch(getUserNavigationConfrimPopup(false));
				}
			});
		}
		else {
			setClick(!click);
		}
	}

	// const toggleDropdown = (event) => {
	// 	// setDropdown(!dropdown)
	// 	setAnchorEl1(event.currentTarget);
	// }

	const handleLogout = () => {
		dispatch(logoutUser())
	}

	useEffect(() => {
		setInterval(() => {
			if (localStorage.getItem("idleTime") == "true") {
				localStorage.removeItem("idleTime")
				localStorage.setItem('autoLogout', 'idle');
				handleLogout();
			}
		}, 1000);
	}, []);

	const history = useHistory();
	const classes = useStyles();
	const [anchorEl1, setAnchorEl1] = useState(false);
	const popupRef = useRef();

	const handleClose = () => {
		setAnchorEl1(null);
	};

	const handleMenu = () => {
		handleClose();
	}

	const open1 = Boolean(anchorEl1);

	useEffect(() => {
		const handleClickVBE = (e) => {
			if (!popupRef?.current?.contains(e.target)) {
				handleClose();
			}
		}

		document.addEventListener('mousedown', handleClickVBE, false);

		return function cleanup() {
			document.removeEventListener('mousedown', handleClickVBE, false);
		};
	});

	const [anchorEl, setAnchorEl] = React.useState(null);

	const handleClick1 = (event) => {
		let target = event.currentTarget;
		if (userNavigatingConfrimPopup) {
			Swal.fire({
				heightAuto: false,
				title: "Changes not saved",
				text: "Are you sure to leave this page?",
				icon: "warning",
				showCancelButton: false,
				showDenyButton: true,
				confirmButtonText: "Confirm",
				denyButtonText: "Cancel",
				confirmButtonColor: "#3085d6",
				denyButtonColor: "#c1c1c1",
			}).then((result) => {
				if (result.isConfirmed) {
					setAnchorEl(target);
					dispatch(getUserNavigationConfrimPopup(true));
				}
			});
		}
		else {
			setAnchorEl(event.currentTarget);
		}
	};

	const handleClose1 = () => {
		setAnchorEl(null);
	};

	const handleNaigate = () => {
		if (userNavigatingConfrimPopup) {
			Swal.fire({
				heightAuto: false,
				title: "Changes not saved",
				text: "Are you sure to leave this page?",
				icon: "warning",
				showCancelButton: false,
				showDenyButton: true,
				confirmButtonText: "Confirm",
				denyButtonText: "Cancel",
				confirmButtonColor: "#3085d6",
				denyButtonColor: "#c1c1c1",
			}).then((result) => {
				if (result.isConfirmed) {
					sessionStorage.removeItem("profilePath");
					sessionStorage.removeItem("profileCurrentPath");
					dispatch(getUserNavigationConfrimPopup(false));
					history.push('/');
				}
			});
		}
		else {
			history.push('/');
			sessionStorage.removeItem("profilePath");
			sessionStorage.removeItem("profileCurrentPath");
		}
	}

	//Switch Learner Profile
	const handleSwitchProfile = (profile_id) => {
		let data = {
			"user_id": userProfile?.user_id,
			"profile_id": profile_id
		}
		axios.post(serverUrl.SwitchProfile, data).then(resp => {
			if (resp.status === 200) {
				dispatch(loadUser());
				// history.push('/');
				window.location.href = '/';
			}
		}).catch(err => {
			tokenAuthorize(err?.response?.status);
		});
	}
	return (
		<nav
			className="py-10 w-full z-10 bg-white"
		>
			<BgBlue className="flex flex-row items-center relative layer px-2 xl:px-24">
				<Link to="/" onClick={(e) => { e.preventDefault(); handleNaigate() }} className={`h-full ${!reflectionFeedbackProcessing ? 'cursor-pointer' : 'cursordisabled'}`}>
					<img className="h-full w-auto" src={COMPANY_LOGO} alt="logo"></img>
				</Link>
				{isNavShown && <>
					<div
						className={`block lg:hidden absolute right-5 ${!reflectionFeedbackProcessing ? 'cursor-pointer' : 'cursordisabled'}`}
						onClick={handleClick}
					>
						<img src={click ? Cross : HamburgerIcon} alt="icon"></img>
					</div>
					<div className="hidden lg:flex lg:flex-row lg:items-center absolute lg:right-5 xl:right-24">

						{userMenuFinal?.map((value, index) => (
							<NavbarLink
								key={index}
								icon={value.icon}
								title={value.title}
								url={value.url}
								numNotif={0}
								isVBE={(value.title == "vbe" || value.title == "VBE") ? true : false}
							/>
						))}

						<div className="flex items-center">
							<ul className="">
								<li
								>
									<div className={`flex items-center ${!reflectionFeedbackProcessing ? 'cursor-pointer' : 'cursordisabled'}`}
										aria-controls="simple-menu"
										aria-haspopup="true"
										onClick={handleClick1}
									>
										<img className="mr-2 rounded-full w-10 h-10" src={profilePhoto} alt="icon"></img>
										<img className="hover:opacity-80" src={DropdownIcon} alt="icon"></img>
									</div>
									<div>
										<MenuItemCard>
											<Menu
												id="simple-menu"
												anchorEl={anchorEl}
												keepMounted
												open={Boolean(anchorEl)}
												onClose={handleClose1}
												classes={{ paper: classes.customMenu }}
											>
												<MenuItemCard>
													{learnerProfile.length != 0 && <>
														<div className="text-sm text-gray-600 px-3">
															Select profile
														</div>
														{learnerProfile?.length && learnerProfile.map((i) => (
															<MenuItem title={i.name} className="flex gap-1.5 switchProfile" onClick={() => {
																// handleSubmenuClose();
																// handleClose1();
																handleSwitchProfile(i.profile_id);
															}}><img src={getProfilePic(i.photo)} title={i.name} alt="pics" className="rounded-full w-8 h-8 object-cover" />
															<p className="whitespace-normal break-all">{i.name}</p>
																{i.is_active && <CheckCircleIcon sx={{ color: 'green' }} />}
															</MenuItem>
														))}
														<hr className="mb-1.5"/>
													</>}
													<MenuItem  className="pt-2" onClick={() => history.push("/account-settings")}>
														<MenuItemDiv>
															Edit Profile
														</MenuItemDiv>
													</MenuItem>
													{/*{learnerProfile.length != 0 && <>
														{/* Nested Menu Trigger 
														< MenuItem
															onMouseEnter={handleSubmenuOpen}
															onMouseLeave={handleSubmenuClose}
															aria-haspopup="true"
														>
															<div className="flex justify-between">
																Learner Profiles
																<ArrowRightIcon fontSize="small" />
															</div>
															{/* Nested Menu 
															<Menu
																anchorEl={subMenuAnchor}
																open={Boolean(subMenuAnchor)}
																onClose={handleSubmenuClose}
																id="switchProfiles"
																anchorOrigin={{ vertical: "top", horizontal: "right" }}
																transformOrigin={{ vertical: "top", horizontal: "left" }}
																className={classes.nestedMenu}
															>
																<div className={classes.nestedContent}>
																	{learnerProfile?.length && learnerProfile.map((i) => (
																		<MenuItem title={i.name} className="flex gap-1.5 switchProfile" onClick={() => {
																			handleSubmenuClose();
																			handleClose1();
																			handleSwitchProfile(i.profile_id);
																		}}>{trimString(i.name, 15)}
																			{i.is_active && <CheckCircleIcon sx={{ color: 'green' }} />}
																		</MenuItem>
																	))}

																</div>
															</Menu>
														</MenuItem>
													</>}*/}
													<MenuItem onClick={handleLogout}>
														<MenuItemDiv>
															Sign Out
														</MenuItemDiv>
													</MenuItem>
												</MenuItemCard>
											</Menu>
										</MenuItemCard>
									</div>
									{/* {dropdown && (
									<NavCard
										className={`${"hidden md:block absolute md:w-32 lg:w-44 mt-3.5 p-3 rounded-md filter-none drop-shadow transform -translate-x-28"}`}
									>
										<li className="md:pb-2 pl-2">
											<LiDiv
												className="flex items-center md:mt-2 hover:opacity-70 cursor-pointer"
												onClick={() => history.push("/account-settings")}
											>
												<p className={`${"text-sm font-semibold"}`}>Edit Profile</p>
											</LiDiv>
											{/* <div 
												className="flex items-center md:mt-2 hover:opacity-70 cursor-pointer"
												onClick={() => history.push("/")}
											>
												<p className="text-sm font-semibold">Help & User Guides</p>	
											</div> 
											<LiDiv
												className="flex items-center md:mt-2 hover:opacity-70 cursor-pointer"
												onClick={handleLogout}
											>
												<p className={`${"text-sm font-semibold"}`}>Sign Out</p>
											</LiDiv>
										</li>
									</NavCard>
								)} */}
								</li>
							</ul>

						</div>

					</div>
				</>}
			</BgBlue >

			{isNavShown && click && (
				<div className="block h-4/5 lg:hidden static w-full  z-50 mt-10 bg-black bg-opacity-60
				overflow-scroll fixed">

					<Card
						className="block  lg:hidden py-5 w-full px-5 absolute z-10 text-black space-y-5"

					>
						<div>
							<div className="flex items-center mr-5 mt-5 pb-2">
								<img className="mr-2 rounded-full h-10 w-10" src={profilePhoto} alt="icon"></img>
								<div>
									<p className="text-lg font-bold">{username}</p>
									<TextGray className="text-sm ">{email}</TextGray>
								</div>
							</div>

						</div>
						{userMenuFinal?.map((value, index) => (

							<NavbarLink
								key={index}
								icon={value.mobileIcon}
								title={value.title}
								url={value.url}
								numNotif={0}
								isVBE={(value.title == "vbe" || value.title == "VBE") ? true : false}
							// vbeList={vbelist}
							/>

						))}

						<TextDarkBlue className="pb-2">
							<div
								className="flex items-center mr-5"
								onClick={() => history.push("/account-settings")}
							>
								<img className="mr-2" src={EditProfileIcon} alt="icon"></img>
								<p className="text-sm">Edit Profile</p>
							</div>
							{/* Learner Profile */}
							{learnerProfile.length != 0 && <>
								<div className="cursor-pointer flex items-center pt-4" onClick={() => setMblsubMenuAnchor(!mblsubMenuAnchor)}>
									<img className="mr-2" src={EditProfileIcon} alt="icon"></img>
									<p className="text-sm pt-1">Learner Profiles</p>
									{mblsubMenuAnchor ? <ExpandLess className="pt-0.5" />
										: <ExpandMore className="pt-0.5" />}
								</div>
								<div className="mx-9" id="basic-button" style={{ display: !mblsubMenuAnchor && "none" }}>
									{learnerProfile?.length > 0 &&
										learnerProfile.map((i, ind) => (
											<>
												<div className="flex mt-4 gap-2 cursor-pointer" key={ind} id={ind} title={i.name}
													onClick={() => {
														handleSubmenuClose();
														handleSwitchProfile(i.profile_id);
													}}
												>
													<p className="font-normal flex gap-1.5 text-sm cursor-pointer items-center hover:opacity-80" id={ind}>
														{/* {trimString(i.name, 25)} */}
														<img src={getProfilePic(i.photo)} title={i.name} alt="pics" className="rounded-full w-8 h-8 object-cover" />
														{i.name}
														{i.is_active && <CheckCircleIcon sx={{ color: 'green' }} />}
													</p>
												</div>
											</>
										))}
								</div>
							</>}
							<div
								className="flex items-center mr-5 mt-4"
								onClick={handleLogout}
							>
								<img className="mr-2" src={LogoutIcon} alt="icon"></img>
								<p className="text-sm">Sign Out</p>
							</div>
						</TextDarkBlue>

					</Card>
				</div>

			)
			}
		</nav >
	)
}

export default Navbar